import http from '../http'
import { Res } from '../type'
import { ISimpleRes, IOverRes, IListObj, IListRes, IStraightRes, IDefaultsRes } from '../Models/HoursRank'

// 个人中心首页查积分用户学时信息
export const getUserSimple = (data: {}): Res<ISimpleRes> => {
  return http.request({
    url: '/sands-lms/api/v1/dailyStudyRecords/simpleInfo',
    method: 'post',
    data,
    loadingShow: '0'
  })
}
// 学习时长详情
export const getHoursOver = (data: {}): Res<IOverRes> => {
  return http.request({
    url: '/sands-lms/api/v1/dailyStudyRecords/overview',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 学时明细
export const getHoursRecords = (data: IListObj): Res<IListRes> => {
  return http.request({
    url: '/sands-lms/api/v1/dailyStudyRecords/detail',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 排行榜
export const getStraightRecords = (data: IListObj): Res<IStraightRes> => {
  return http.request({
    url: '/sands-lms/api/v1/dailyStudyRecords/rank',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 查询默认部门
export const getDefaultDeptInfo = (params: {}): Res<IDefaultsRes> => {
  return http.request({
    url: '/sands-user/api/v1/dept/getDefaultDepts',
    method: 'get',
    params,
    loadingShow: '0'
  })
}

// 查询部门组织架构
export const getDefaultQueryInfo = (data: { parentId: string }): Res<IStraightRes> => {
  return http.request({
    url: '/sands-user/api/v1/dept/query',
    method: 'post',
    data,
    loadingShow: '0'
  })
}
